const luhnArray = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]; // f(x) = (x*2) / 10 + (x*2) % 10

function luhnSum(s: string): number {
	return s.split('').map(x => parseInt(x))
		.reverse()
		.reduce((p, c, i) => p + ((i % 2 === 0) ? c : luhnArray[c]), 0);
}

export function validateLuhn(value: string): boolean  {
	// remove whitespace
	const s = value.replace(/\s/g, '');

	const counter = luhnSum(s);
	return (counter % 10 === 0);
}
